import type { GigTemplate } from "api/resources/templates";
import { atomWithStorage } from "jotai/utils";
import { safeJSONStorage } from "utils/safeStorage";

export const connectSkillAtom = atomWithStorage<Omit<GigTemplate, "id" | "name" | "location_id"> | undefined>(
  "connect_skill",
  undefined,
  safeJSONStorage<Omit<GigTemplate, "id" | "name" | "location_id"> | undefined>(),
  { getOnInit: true },
);
